export default __webpack_public_path__ + "static/media/order-delivered-icon.6911c6b2.svg";